module.exports = __webpack_public_path__ + "img/slide_p1.8a4898ae.png";